import React from 'react';
import PropTypes from 'prop-types';
import CreditCard from '../../../common/CreditCard';
import { t } from '../../../../modules/infra/i18n';

const CardSelected = ({ card, changeCard }) => (
  <div display-if={card}>
    <div className="o-flexbox">
      <div className="o-flexbox__item u-flex-1">
        <CreditCard className="c-input is-disabled">{card}</CreditCard>
      </div>
      <div className="o-flexbox__item u-pl-">
        <button
          className="c-btn c-btn--medium u-ph--"
          onClick={changeCard}
          type="button"
        >
          {t('register:payment.card.use_different_card')}
        </button>
      </div>
    </div>
  </div>
);
CardSelected.propTypes = {
  card: PropTypes.shape({
    last4: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
  }),
  changeCard: PropTypes.func.isRequired,
};
CardSelected.defaultProps = {
  card: null,
};

export default CardSelected;
